export const trackerMap = {
    SYS: ['CLICK_SIDEBAR', 'LOG_OUT', 'LOGIN'],
} as const;

// export type EventMap = {
//     test: {
//         name: string
//     },
//     test2: {
//         name2: string
//     }
// }
export type TrackEvent = 
    'from_clinic'
    | 'from_leaflet'
    | 'cover_view'
    | 'cover_startBtn_click'
    | 'cover_agreement_agree'
    | 'cover_agreement_refuse'
    | 'cover_auth_agree'
    | 'cover_auth_refuse'
    | 'scan_view'
    | 'scan_cupAni_show'
    | 'scan_microscopeBtn_click'
    | 'scan_microscopeAni_show'
    | 'scan_video_end'
    | 'scan_ball_click'
    | 'scan_screen_slide'
    | 'scan_moreBtn_click'
    | 'scan_scan_success'
    | 'scan_scan_fail'
    | 'scan_toast_show'
    | 'scan_popup_show'
    | 'scan_reScanBtn_click'
    | 'cover_terms_show'
    | 'cover_terms_hide'
    | 'cover_privacy_show'
    | 'cover_privacy_hide'
    | 'scan_compareBtn_click'
    | 'compare_backBtn_click'
    | 'compare_moreBtn_click'
    | 'scan_cupAni_view'
    | 'result_view'
    | 'compare_view'


export const eventNameMap: Record<TrackEvent, string> = {
    'from_leaflet': '传单渠道进入',
    'from_clinic': '门诊渠道进入',
    'cover_agreement_agree': '重要声明弹窗—点击允许',
    'cover_agreement_refuse': '重要声明弹窗—点击不允许',
    'cover_auth_agree': '授权摄像头弹窗-点击同意',
    'cover_auth_refuse': '授权摄像头弹窗-点击拒绝',
    'cover_privacy_hide': '点击【隐私政策】关闭按钮',
    'cover_privacy_show': '点击显示【隐私政策】',
    'cover_startBtn_click': '点击【扫描罐身】按钮',
    'cover_terms_hide': '点击关闭【服务条款】',
    'cover_terms_show': '点击显示【服务条款】',
    'cover_view': '进入落地页数量',
    'scan_ball_click': '点击【乳脂球】',
    'scan_cupAni_show': '播放杯子动画',
    'scan_microscopeAni_show': '播放显微镜动画',
    'scan_microscopeBtn_click': '点击【显微镜】按钮（自动触发也计入）',
    'scan_moreBtn_click': '点击了解更多按钮',
    'scan_popup_show': '识别失败12次后，重新识别弹窗显示',
    'scan_reScanBtn_click': '点击【重新识别】按钮',
    'scan_scan_fail': '识别失败次数',
    'scan_scan_success': '识别成功次数',
    'scan_screen_slide': '左右滑动分子球操作',
    'scan_toast_show': '识别失败五次后，toast 显示',
    'scan_video_end': '插播小视频播放结束',
    'scan_view': '进入扫一扫页',
    'scan_compareBtn_click': '对比原生脂球按钮',
    'compare_backBtn_click': '至熠3D乳黄金球按钮',
    'compare_moreBtn_click': '点击了解更多',
    'scan_cupAni_view': '冲调页面进入数量',
    'result_view': '分子球页面进入数量',
    'compare_view': '对比页面进入数量'
}